import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AppLanguage, changeAppLanguage } from "_i18n/i18n";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLang = (i18n.language || "pl").startsWith("en") ? "en" : "pl";

  const setLanguage = (language: AppLanguage) => {
    if (currentLang === language) return;
    void changeAppLanguage(language);
  };

  return (
    <Wrapper aria-label="Language">
      <LangButton
        type="button"
        $active={currentLang === "pl"}
        onClick={() => setLanguage("pl")}
      >
        PL
      </LangButton>
      <Divider>/</Divider>
      <LangButton
        type="button"
        $active={currentLang === "en"}
        onClick={() => setLanguage("en")}
      >
        ENG
      </LangButton>
    </Wrapper>
  );
};

export default LanguageSwitcher;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 10px;
`;

const Divider = styled.span`
  color: #909090;
  font-size: 12px;
  line-height: 1;
`;

const LangButton = styled.button<{ $active: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px 4px;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 700 : 400)};
  color: ${({ $active }) => ($active ? "#9cb0c4" : "#606060")};
  opacity: ${({ $active }) => ($active ? 1 : 0.7)};

  &:hover {
    color: #9cb0c4;
    opacity: 1;
  }
`;
